import React from 'react';
import { processSteps, industries, companyInfo } from '../mockData';
import { CheckCircle2 } from 'lucide-react';

const About = () => {
  return (
    <div className="page-container">
      {/* About Hero */}
      <section className="about-hero-section">
        <div className="container">
          <h1 className="heading-1">ABOUT VAIKUNTHA MEDIA</h1>
          <p className="body-large max-w-4xl">
            {companyInfo.description}
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="section-padding bg-card">
        <div className="container">
          <div className="mission-vision-grid">
            <div className="mission-card">
              <h2 className="heading-4">OUR MISSION</h2>
              <p className="body-medium">
                To empower clients by building meaningful connections, amplifying their impact, 
                and delivering effective solutions through strategic and integrated communication approaches.
              </p>
            </div>
            <div className="vision-card">
              <h2 className="heading-4">OUR VISION</h2>
              <p className="body-medium">
                {companyInfo.vision}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="section-padding">
        <div className="container">
          <h2 className="heading-2 text-center mb-96">OUR VALUES</h2>
          <div className="values-grid">
            <div className="value-item">
              <CheckCircle2 size={24} className="value-icon" />
              <h3 className="heading-5">Client-Centric Intent</h3>
              <p className="body-small">
                Focusing on ethical practices and delivering solutions that genuinely 
                satisfy client needs and exceed expectations.
              </p>
            </div>
            <div className="value-item">
              <CheckCircle2 size={24} className="value-icon" />
              <h3 className="heading-5">Data & Technology Backbone</h3>
              <p className="body-small">
                Leveraging data specialists and tech experts to ensure precision and 
                measurable outcomes in every project.
              </p>
            </div>
            <div className="value-item">
              <CheckCircle2 size={24} className="value-icon" />
              <h3 className="heading-5">Cultural Intelligence</h3>
              <p className="body-small">
                Understanding and respecting diverse markets with cultural sensitivity 
                and local insights for global impact.
              </p>
            </div>
            <div className="value-item">
              <CheckCircle2 size={24} className="value-icon" />
              <h3 className="heading-5">Ethical Practice</h3>
              <p className="body-small">
                Operating within regulatory frameworks with integrity, transparency, 
                and industry responsibility in all our engagements.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Process */}
      <section className="section-padding bg-card">
        <div className="container">
          <h2 className="heading-2 text-center mb-96">OUR STRATEGIC PROCESS</h2>
          <p className="body-large text-center max-w-3xl mx-auto mb-96">
            A strategic, end-to-end process designed to deliver measurable outcomes 
            and sustainable growth for your business.
          </p>
          <div className="process-grid">
            {processSteps.map((step) => (
              <div key={step.number} className="process-card">
                <div className="process-number">{step.number}</div>
                <h3 className="heading-4">{step.title}</h3>
                <p className="caption">{step.subtitle}</p>
                <p className="body-small">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries We Serve */}
      <section className="section-padding">
        <div className="container">
          <h2 className="heading-2 text-center mb-96">INDUSTRIES WE SERVE</h2>
          <p className="body-large text-center max-w-3xl mx-auto mb-96">
            Primary experience across India and all major Global Markets, delivering 
            solutions across diverse industries and business engagement models.
          </p>
          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-card">
                <h3 className="heading-5">{industry.title}</h3>
                <p className="body-small">{industry.description}</p>
              </div>
            ))}
          </div>
          <div className="business-models">
            <p className="caption text-center">BUSINESS ENGAGEMENT MODELS</p>
            <div className="models-list">
              <span className="model-badge">B2B</span>
              <span className="model-badge">B2C</span>
              <span className="model-badge">D2C</span>
              <span className="model-badge">Hybrid Commerce</span>
            </div>
          </div>
        </div>
      </section>

      {/* Company Stats */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">2018</div>
              <div className="stat-label">Founded</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">10+</div>
              <div className="stat-label">Service Offerings</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">Global</div>
              <div className="stat-label">Market Reach</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">Client-Centric</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
